module.exports = __webpack_public_path__ + "static/media/ipadpro2_splash.e5472428.png";